import { render, staticRenderFns } from "./provider-addmanualattendees.vue?vue&type=template&id=70ea25c6&scoped=true"
import script from "./provider-addmanualattendees.vue?vue&type=script&lang=js"
export * from "./provider-addmanualattendees.vue?vue&type=script&lang=js"
import style0 from "./provider-addmanualattendees.vue?vue&type=style&index=0&id=70ea25c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea25c6",
  null
  
)

export default component.exports